// „Löschen …“ (context menu): what the confirmation dialog shows before DELETE compta/documents/:id.
// The backend decides (closed month, open preparation → 409 with a code); this only explains what is known up front.
import type { DocDetail } from './docEdit';

export interface DeletePlan {
  /** Ticked with a statement booking: deleting is refused until the tick is removed under Abschluss. */
  reconciled: boolean;
  /** Paid: payments are deleted with it, needs the explicit checkbox (confirmPaid). */
  paid: boolean;
  payments: number;
  /** Credit-note allocations (invoice side or credit-note side) that are removed with it. */
  allocations: number;
}

export function deletePlan(d: DocDetail): DeletePlan {
  const payments = d.payments?.length ?? 0;
  return {
    reconciled: !!d.reconciledWith?.length,
    paid: d.status === 'PAID' || payments > 0,
    payments,
    allocations: (d.settlement?.credits?.length ?? 0) + (d.usedFor?.length ?? 0),
  };
}

/** May „Löschen“ be clicked? Reconciled never; paid only with the checkbox ticked. */
export const canSubmitDelete = (p: DeletePlan, confirmed: boolean, busy = false) => !busy && !p.reconciled && (!p.paid || confirmed);
